export default __webpack_public_path__ + "dc34e15ef48ed9fe58b7870a3c957306.svg";